const ClearMask = (number: string) => {
  return number
    .replace("R$", "")
    .replace(/\./g, "")
    .replace(/,/g, ".")
    .replace(/\s/g, "");
};

export default ClearMask;
